import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: max-content;

  &:has(.row) {
    min-width: 0;
  }

  .list-container {
    display: flex;
    flex-direction: column;
    &.row {
      flex-direction: row;
      flex-wrap: wrap;
      column-gap: 16px;
    }

    & li {
      margin-bottom: 16px;
    }
  }

  .no-data {
    font-size: 18px;
    color: ${(props) => props.theme.colors.inactive};
    align-self: center;
  }
`;

export default { Wrapper };
